<script lang="ts" setup>
import { QSeparator } from "quasar";
defineProps<{
  text?: string;
}>();
</script>
<template>
  <div v-if="text" class="horizontal-separator">
    <span>{{ text }}</span>
  </div>
  <q-separator v-else />
</template>
<style lang="scss">
.horizontal-separator {
  display: flex;
  flex-direction: row;
  color: var(--grey-darkest);

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  &:before,
  &:after {
    content: " ";
    flex: 1 1;
    border: 1px solid var(--grey-light);
    margin: auto;
  }
}
</style>
